module.exports = __webpack_public_path__ + "static/media/button-check-now.780ac675.png";